<template>
    <div>
        <div v-if="!isShow">
            <div class="jobcard_top" style="height: 200px;">
                <div class="wapper" style="position: relative;height: 200px;">
                    <p class="summary-plane__title">{{jobDetail.name}}</p>
                    <p class="summary-plane__time">更新于 今天</p>
                    <p class="summary-plane__salary">{{jobDetail.salary}}元</p>
                    <p>
                        <span>{{setEducation(jobDetail.education)}}</span>
                        <span> | </span>
                        <span>{{jobDetail.experience=='不限'?'工作经验不限':jobDetail.experience}}</span>
                    </p>
                    <div style="margin-top: 10px;">
                        <el-tag
                                style="margin-right: 10px;"
                                v-for="(tag,idx) in labelList"
                                :key="tag">
                            {{tag}}
                        </el-tag>
                    </div>
                    <a class="link_hr" :href="'tel:' + jobDetail.link">{{jobDetail.linkName}}：{{jobDetail.link}}</a>
               </div>
            </div>
            <el-card class="jobcard" style="margin-bottom: 10px;">
                <div class="jobintroduce">职位介绍</div>
                <div class="jobcontent">
                    <p v-html="jobDetail.content"></p>
                </div>
                <div class="jobintroduce">工作地点</div>
                <div class="jobcontent">
                    <p>{{jobDetail.address}}</p>
                </div>
                <div class="jobintroduce">联系hr</div>
                <div class="hrinfo">
                    <span>{{jobDetail.linkName}}：{{jobDetail.link}}</span>
                </div>
            </el-card>
        </div>
    </div>

</template>
<style>
    * {
        box-sizing: border-box;
    }
    p span{
        margin: 0;
        padding: 0;
    }
    .jobcard_top{
        text-align: left;
        background-color: #f5faff;
    }
    .wapper{
        width: 1000px;
        margin: 0 auto;
        overflow: hidden;
    }
    .summary-plane__title{
        clear: both;
        color: #333;
        font-size: 24px;
        font-weight: 700;
        line-height: 1.2;
        margin-bottom: 8px;
        margin-top: 44px;
    }
    .summary-plane__time{
        color: #9497a1;
        cursor: pointer;
        font-size: 12px;
    }
    .summary-plane__salary{
        color: #ff424f;
        font-size: 28px;
        font-weight: 700;
        line-height: 24px;
        overflow: hidden;
        margin-top: 12px;
        position: absolute;
        right: 20px;
        top: 40px;
    }
    .link_hr{
        text-decoration: none;
        display: block;
        font-size: 16px;
        font-weight: 700;
        height: 48px;
        width: 240px;
        background: none;
        border: 1px solid #1787fb;
        border-radius: 4px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
        height: 48px;
        line-height: 48px;
        margin-right: 10px;
        text-align: center;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: #1787fb;
        color: #fff;
        position: absolute;
        right: 20px;
        bottom: 20px;
    }
    .summary-plane__address{
        font-size: 14px;
        margin-top: 12px;
    }
    body {
        margin: 0;
        padding: 0;
    }

    div .jobcard {
        width: 1000px;
        margin: 20px auto auto auto;
    }

    .avatar {
        float: left;
        width: 126px;
        height: 110px;
    }

    .title {
        font-size: 21px;
    }

    .introduce {
        margin-left: 140px;
        height: 110px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .introduce p {
        margin: 8px;
    }

    .jobintroduce {
        border-left: 5px solid #888;
        text-align: left;
        padding-left: 8px;
    }

    .jobcontent {
        min-height: 40px;
        margin: 15px auto 15px auto;
        text-align: left;
    }

    .hrinfo {
        margin: 14px auto 42px auto;
        float: left;
    }

    .hrinfo span {
        margin-right: 14px
    }

    .jobbtn {
        float: right;
        margin-bottom: 20px;
    }
</style>

<script>
    import fetch from '../api/fetch'
    import getData from "@/api/getData";
    export default {
        data() {
            return {
                company: [],
                hr: [],
                recruit: [],
                recruitId: 0,
                title: '',
                isShow: false,
                jobId: '',
                jobDetail: {},
                labelList: []
            }
        },
        created(){
            this.jobId = this.$route.query.id
        },
        mounted() {
            this.getJobDetail()
        },
        computed: {
            isHr() {
                if (localStorage.getItem('role') === '1') {
                    return true
                }
                return false
            },
            isLogin() {
                return localStorage.getItem('token') ? true : false
            }
        },
        methods: {
            setEducation(v) {
                if (v == '1') {
                    return '初中及以下'
                } else if (v == '2') {
                    return '高中'
                } else if (v == '3') {
                    return '本科'
                } else if (v == '4') {
                    return '专科'
                } else if (v == '5') {
                    return '硕士及以上'
                } else if (v == '9') {
                    return '学历不限'
                }
            },
            getJobDetail() {
                getData.get('https://nocoapi.kuailework.com/api/v2/tables/mp4l49rzxw9n1zo/records',{
                    where: '(id,eq,' + this.jobId + ')'
                }).then(res =>{
                    console.log(res)
                    if(res.data && res.data.list && res.data.list.length > 0){
                        this.jobDetail = res.data.list[0]
                        this.labelList = this.jobDetail.label?this.jobDetail.label.split(','):[]
                    }else{
                        this.jobDetail = {}
                        this.labelList = []
                    }
                })
            },
            sendResume() {
                let body = {
                    recruitId: this.recruitId,
                    title: this.title
                }
                fetch.deliveryReusme(body).then(res => {
                    if (res.status === 200) {
                        this.$message({
                            message: res.data.data,
                            type: 'success'
                        })
                    }
                }).catch(e => {
                    console.log(e)
                })
            }
        },
    }
</script>
